import Features from "@app/feature-flags/features";
import ServiceBase from "@app/shared/serviceBase";

/** Handles querying the 2.0 API for feature flag status */
export default class FeatureFlagService extends ServiceBase {
  private featureFlagsEndpoint = `${this.apiEndpoint}/feature-flags`;

  public async getAllEnabledFeatures(signal?: AbortSignal): Promise<Set<Features>> {
    return new Set(await this.makeGet<Features[]>("get-enabled-features", null, this.featureFlagsEndpoint, undefined, undefined, signal));
  }
}
